import AvatarImage from 'components/functional/images/AvatarImage';
import moment from 'moment';
import React from "react";
import { Card, CardBody, CardHeader, CardText, Col, Row } from "reactstrap";

class ProjectWork extends React.Component {

    state = {
        navPill: 1,
        project: {},
        project_logs_clients: [],
    }

    render() {

        const project_logs_clients = this.props.project_logs_clients;

        return (
            <>

                <Card>

                    <CardHeader>
                        <h2 className="mb-0">Project Work Done</h2>
                        <CardText>This page shows a log of what we are doing, where we are at, and the development progress of this project.</CardText>
                    </CardHeader>

                    <CardBody>

                        {project_logs_clients.length ? project_logs_clients.map(p => (

                            <div className="mb-">
                                <Row className="algin-self-center mb-3">
                                    <div className="col" style={{width: 65}}>
                                        <span  className="avatar rounded-circle mt-2">
                                            <AvatarImage src={p.user.picture_url} />
                                        </span>
                                    </div>
                                    <div  className="col-auto" style={{width: 'calc(100% - 65px)'}}>
                                        <p className="mb-0 text-sm mt-2 font-weight-bold">
                                            {p.user.given_name}{' '}{p.user.family_name}
                                        </p>
                                        <p className="mb-0 text-sm">{moment.unix(p.created_at).format("MM/DD/YYYY") + ' at ' + moment.unix(p.created_at).format("h:mm A")}</p>
                                    </div>
                                </Row>


                                <h4 className="mb-0">Status</h4>                                        
                                <p className="text-sm text-muted mb-3">{p.description}</p>

                                <Row>
                                    <Col lg={4} className="">
                                        <h4 className="mb-0">Total Time (minutes)</h4>    
                                        <p className="text-sm text-muted  mb-3 mb-0">{p.minutes}</p>
                                    </Col>
                                    <Col lg={4} className="text-left text-lg-center">
                                        <h4 className="mb-0">Material Cost</h4>    
                                        <p className="text-sm text-muted mb-3 mb-0">${(p.cost_material / 100).toFixed(2)}</p>
                                    </Col>
                                    <Col lg={4} className="text-left text-lg-right">
                                        <h4 className="mb-0 text-success font-weight-bold">Task Billable</h4>    
                                        <p className="text-sm text-muted  mb-0">${((p.cost_labor / 100) + p.cost_material / 100).toFixed(2)}</p>
                                    </Col>
                                </Row>

                                <hr className="my-2 mb-4 mx--4"/>
                            </div>

                        )): <h2>There are no entries for this project yet.</h2>}

                    </CardBody>
                </Card>

             
            </>
        );
    }
}

export default ProjectWork

